import { CasTabButtonsView } from 'src/compass/shared/components';
import RequestTypesTab from './requestTypesTab/RequestTypesTab';
import AgenciesTab from './agenciesTab/AgenciesTab';
import GrowersTab from './GrowersTab';

export default function SettingsTab() {
  return (
    <CasTabButtonsView
      buttonList={[
        { label: 'Request Types', children: <RequestTypesTab /> },
        { label: 'Growers', children: <GrowersTab /> },
        { label: 'Agencies', children: <AgenciesTab /> },
      ]}
    />
  );
}
